import React, { useEffect, useRef } from 'react'

/**
 * Custom Hook to access values from previous rendering.
 * It can be used to access previous properties or state, like
 * it was possible with deprecated componentWillReceiveProps
 * lifecycle method.
 *
 * Taken from: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 *
 * @param {*} value - An arbitrary value to be stored
 * @return {*}
 */
function usePrevious(value) {
    const ref = useRef()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

export { usePrevious }
